import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  collection,
  query,
  where,
  getDocs,
} from 'firebase/firestore';
import { db } from '../firebase';
import PostCard from '../components/PostCard';
import styles from './PostsPage.module.css';

function UserPostsPage() {
  const { currentUser } = useAuth();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) {
      return;
    }

    const fetchPosts = async () => {
      setLoading(true);
      try {
        // Récupérer tous les posts sans orderBy pour éviter le besoin d'index composite
        const q = query(
          collection(db, 'posts'),
          where('userId', '==', currentUser.uid),
        );
        const snapshot = await getDocs(q);
        const postsData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        // Trier côté client par date décroissante
        postsData.sort((a, b) => {
          const aDate = a.createdAt?.toDate ? a.createdAt.toDate() : (a.createdAt ? new Date(a.createdAt) : new Date(0));
          const bDate = b.createdAt?.toDate ? b.createdAt.toDate() : (b.createdAt ? new Date(b.createdAt) : new Date(0));
          return bDate.getTime() - aDate.getTime();
        });
        setPosts(postsData);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching posts:', error);
        setPosts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, [currentUser]);

  if (loading) {
    return (
      <div className={styles.page}>
        <div className={styles.container}>
          <div className={styles.loading}>Chargement...</div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h1>Mes questions</h1>
          <Link to="/posts/create" className={styles.createPostBtn}>
            + Poser une question
          </Link>
        </div>
        {posts.length > 0 ? (
          <div className={styles.postsList}>
            {posts.map((post) => (
              <PostCard key={post.id} post={post} currentUser={currentUser} />
            ))}
          </div>
        ) : (
          <div className={styles.empty}>Aucune question pour le moment</div>
        )}
      </div>
    </div>
  );
}

export default UserPostsPage;

